import {
  Box,
  IconButton,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import React from 'react';



export type ReportLinkCardProps = {
  id: string;
  name: string;
  url: string;
  handleDelete: () => void;
};


/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ReportLinkCardProps) => {
  const theme = useTheme();

  const handleDownload = (url: string) => {
    let cleanedUrl = url.toLowerCase().replace('https://www.', '');
    cleanedUrl = url.toLowerCase().replace('http://www.', '');
    cleanedUrl = url.toLowerCase().replace('https://', '');
    cleanedUrl = url.toLowerCase().replace('http://', '');
    window.open(`https://${cleanedUrl}`, '_blank');
  };

  return (
    <Stack
      direction='row'
      borderRadius='1rem'
      bgcolor={theme.palette.secondary.main}
      padding='1rem'
      justifyContent='space-between'
      rowGap='.5rem'
    >
      <Box>
        <Box>
          <Typography
            variant='bodyBold'
          >
            {props.name}
          </Typography>
        </Box>
        <Box>
          <Typography >
            url: {props.url}
          </Typography>
        </Box>
      </Box>
      <Box>

        <IconButton
          onClick={() => {
            handleDownload(props.url);
          }}
          sx={{
            cursor: 'pointer'
          }}
        >
          <CustomIcon.large.FC
            icon='BOOKMARK'
            stroke={theme.palette.primary.main}
          />
        </IconButton>
        <IconButton
          onClick={() => {
            props.handleDelete();
          }}
          sx={{
            cursor: 'pointer'
          }}
        >
          <CustomIcon.large.FC

            icon='DELETE'
            stroke={theme.palette.error.main}
          />
        </IconButton>
      </Box>
    </Stack>
  );
};
